import { useEffect, useState } from "react";

import {
  collection,
  getDocs,
  addDoc,
  serverTimestamp,
  query,
  where
} from "firebase/firestore";

import { db } from "../../firebase";

import {
  transferStock
} from "../../services/inventoryService";

export default function StockTransfer() {

  const [inventory, setInventory] =
    useState([]);

  const [locations, setLocations] =
    useState([]);

  const [submitting, setSubmitting] =
    useState(false);

  const [form, setForm] = useState({

    from_location: "",

    to_location: "",

    item_id: "",

    item_name: "",

    qty: "",

    unit: "nos",

    transfer_reason: "",

    approved_by: ""
  });

  // =========================================
  // LOAD DATA
  // =========================================

  useEffect(() => {

    fetchInventory();

    fetchLocations();

  }, []);

  // =========================================
  // FETCH INVENTORY
  // =========================================

  const fetchInventory = async () => {

    try {

      const user = JSON.parse(localStorage.getItem("user") || "{}");
const companyId = user.company_id || "";
const snap =
  await getDocs(
    query(
      collection(db, "inventory_summary"),
      where("company_id", "==", companyId)
    )
  );

      const data =
        snap.docs.map((doc) => ({

          id: doc.id,

          ...doc.data()
        }));

      setInventory(data);

    } catch (error) {

      console.error(
        "Inventory fetch failed:",
        error
      );
    }
  };

  // =========================================
  // FETCH LOCATIONS
  // =========================================

  const fetchLocations = async () => {

    try {

      const user = JSON.parse(localStorage.getItem("user") || "{}");
const companyId = user.company_id || "";
const snap =
  await getDocs(
    query(
      collection(db, "projects"),
      where("company_id", "==", companyId)
    )
  );

      const projectLocations =
        snap.docs.map(
          (doc) =>

            doc.data().site_name ||

            doc.data().project_name
        );

      setLocations([

        "Central Store",

        ...projectLocations.filter(
          Boolean
        )
      ]);

    } catch (error) {

      console.error(
        "Location fetch failed:",
        error
      );
    }
  };

  // =========================================
  // FORM CHANGE
  // =========================================

  const handleChange = (
    field,
    value
  ) => {

    setForm((prev) => ({

      ...prev,

      [field]: value
    }));
  };

  // =========================================
  // ITEM SELECT
  // =========================================

  const handleItemSelect = (
    itemId
  ) => {

    const selected =
      inventory.find(
        (x) =>
          x.id === itemId
      );

    if (!selected) return;

    setForm((prev) => ({

      ...prev,

      item_id:
        selected.id,

      item_name:
        selected.item_name,

      unit:
        selected.unit || "nos"
    }));
  };

  // =========================================
  // SUBMIT
  // =========================================

  const handleSubmit = async () => {

    if (submitting) return;

    // =========================
    // VALIDATION
    // =========================

    if (

      !form.from_location ||

      !form.to_location ||

      !form.item_id ||

      !form.qty ||

      Number(form.qty) <= 0
    ) {

      alert(
        "Fill all required fields"
      );

      return;
    }

    if (

      form.from_location ===
      form.to_location
    ) {

      alert(
        "Source and destination cannot be same"
      );

      return;
    }

    try {

      setSubmitting(true);

      const qty =
        Number(form.qty);

      // =========================
      // INVENTORY ITEM
      // =========================

      const selectedInventory =
        inventory.find(
          (x) =>
            x.id === form.item_id
        );

      if (!selectedInventory) {

        alert(
          "Inventory item not found"
        );

        return;
      }

      // =========================
      // STOCK CHECK
      // =========================

      const currentStock =
        Number(
          selectedInventory.qty || 0
        );

      if (qty > currentStock) {

        alert(
          `Insufficient stock. Available: ${currentStock}`
        );

        return;
      }

      // =========================
      // CENTRALIZED TRANSFER
      // =========================

      await transferStock({

        company_id:

          selectedInventory.company_id ||

          "",

        item_id:
          form.item_id,

        item_code:

          selectedInventory.item_code ||

          "",

        item_name:
          form.item_name,

        category:

          selectedInventory.category ||

          "MATERIAL",

        qty,

        unit:
          form.unit,

        from_location:
          form.from_location,

        to_location:
          form.to_location,

        approved_by:
          form.approved_by,

        remarks:
          form.transfer_reason,
      });

      // =========================
      // TRANSFER RECORD
      // =========================

      await addDoc(

        collection(
          db,
          "stock_transfers"
        ),

        {

          company_id:

            selectedInventory.company_id ||

            "",

          item_id:
            form.item_id,

          item_code:

            selectedInventory.item_code ||

            "",

          item_name:
            form.item_name,

          category:

            selectedInventory.category ||

            "MATERIAL",

          qty,

          unit:
            form.unit,

          from_location:
            form.from_location,

          to_location:
            form.to_location,

          transfer_reason:
            form.transfer_reason,

          approved_by:
            form.approved_by,

          status:
            "completed",

          created_at:
            serverTimestamp()
        }
      );

      // =========================
      // SUCCESS
      // =========================

      alert(
        "Stock transferred successfully"
      );

      // =========================
      // RESET FORM
      // =========================

      setForm({

        from_location: "",

        to_location: "",

        item_id: "",

        item_name: "",

        qty: "",

        unit: "nos",

        transfer_reason: "",

        approved_by: ""
      });

      // =========================
      // REFRESH INVENTORY
      // =========================

      fetchInventory();

    } catch (error) {

      console.error(
        "Stock transfer failed:",
        error
      );

      alert(
        error.message ||
        "Transfer failed"
      );

    } finally {

      setSubmitting(false);
    }
  };

  // =========================================
  // UI
  // =========================================

  return (

    <div className="min-h-screen bg-slate-100 p-6">

      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg border p-8">

        {/* ===================== */}
        {/* BACK BUTTON */}
        {/* ===================== */}

        <button
          onClick={() =>
            window.history.back()
          }
          className="mb-6 px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg font-medium"
        >
          ← Back
        </button>

        {/* ===================== */}
        {/* TITLE */}
        {/* ===================== */}

        <h2 className="text-3xl font-bold mb-8 text-gray-800">

          Stock Transfer System

        </h2>

        {/* ===================== */}
        {/* FORM */}
        {/* ===================== */}

        <div className="grid grid-cols-2 gap-6">

          {/* FROM LOCATION */}

          <div>

            <label className="block mb-2 font-medium">

              From Location

            </label>

            <select
              value={form.from_location}
              onChange={(e) =>

                handleChange(
                  "from_location",
                  e.target.value
                )
              }
              className="w-full border rounded-lg px-4 py-3"
            >

              <option value="">

                Select Source

              </option>

              {locations.map(
                (location, i) => (

                  <option
                    key={i}
                    value={location}
                  >
                    {location}
                  </option>
                )
              )}

            </select>

          </div>

          {/* TO LOCATION */}

          <div>

            <label className="block mb-2 font-medium">

              To Location

            </label>

            <select
              value={form.to_location}
              onChange={(e) =>

                handleChange(
                  "to_location",
                  e.target.value
                )
              }
              className="w-full border rounded-lg px-4 py-3"
            >

              <option value="">

                Select Destination

              </option>

              {locations.map(
                (location, i) => (

                  <option
                    key={i}
                    value={location}
                  >
                    {location}
                  </option>
                )
              )}

            </select>

          </div>

          {/* ITEM */}

          <div className="col-span-2">

            <label className="block mb-2 font-medium">

              Item

            </label>

            <select
              value={form.item_id}
              onChange={(e) =>

                handleItemSelect(
                  e.target.value
                )
              }
              className="w-full border rounded-lg px-4 py-3"
            >

              <option value="">

                Select Item

              </option>

              {inventory.map((item) => (

                <option
                  key={item.id}
                  value={item.id}
                >

                  {item.item_name}

                  {" "}(
                  Available: {item.qty}
                  )

                </option>
              ))}

            </select>

          </div>

          {/* QTY */}

          <div>

            <label className="block mb-2 font-medium">

              Quantity

            </label>

            <input
              type="number"
              min="1"
              value={form.qty}
              onChange={(e) =>

                handleChange(
                  "qty",
                  e.target.value
                )
              }
              className="w-full border rounded-lg px-4 py-3"
            />

          </div>

          {/* UNIT */}

          <div>

            <label className="block mb-2 font-medium">

              Unit

            </label>

            <input
              value={form.unit}
              onChange={(e) =>

                handleChange(
                  "unit",
                  e.target.value
                )
              }
              className="w-full border rounded-lg px-4 py-3"
            />

          </div>

          {/* REASON */}

          <div className="col-span-2">

            <label className="block mb-2 font-medium">

              Transfer Reason

            </label>

            <textarea
              value={form.transfer_reason}
              onChange={(e) =>

                handleChange(
                  "transfer_reason",
                  e.target.value
                )
              }
              className="w-full border rounded-lg px-4 py-3"
              rows="3"
            />

          </div>

          {/* APPROVED BY */}

          <div className="col-span-2">

            <label className="block mb-2 font-medium">

              Approved By

            </label>

            <input
              value={form.approved_by}
              onChange={(e) =>

                handleChange(
                  "approved_by",
                  e.target.value
                )
              }
              className="w-full border rounded-lg px-4 py-3"
            />

          </div>

        </div>

        {/* ===================== */}
        {/* SUBMIT */}
        {/* ===================== */}

        <button
          onClick={handleSubmit}
          disabled={submitting}
          className={`w-full mt-8 py-4 rounded-xl text-white font-bold text-lg ${
            submitting
              ? "bg-gray-400"
              : "bg-indigo-600 hover:bg-indigo-700"
          }`}
        >

          {submitting

            ? "Processing Transfer..."

            : "Transfer Stock"}

        </button>

      </div>

    </div>
  );
}